// Shared mute state for all music tracks (title + race). One toggle, one
// localStorage key. Tracks subscribe so they pause/resume in lockstep.
const STORAGE_KEY = 'tst:title-theme-muted';

type Listener = (muted: boolean) => void;

const listeners = new Set<Listener>();
let muted = readMuted();

export const musicMute = {
  isMuted(): boolean {
    return muted;
  },
  setMuted(next: boolean): void {
    if (next === muted) return;
    muted = next;
    writeMuted(next);
    for (const l of listeners) l(next);
  },
  toggle(): boolean {
    musicMute.setMuted(!muted);
    return muted;
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

function readMuted(): boolean {
  try {
    return typeof localStorage?.getItem === 'function'
      ? localStorage.getItem(STORAGE_KEY) === '1'
      : false;
  } catch {
    return false;
  }
}

function writeMuted(value: boolean): void {
  try {
    if (typeof localStorage?.setItem === 'function') {
      localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    }
  } catch {
    // Ignore storage failures in embedded/test environments.
  }
}
